import React from 'react';
import './HomePage.css'; // Reuse styles for now

const CastList = ({ cast, tmdb_id }) => {
  if (cast === undefined) {
    return (
      <>
        {[...Array(5)].map((_, i) => (
          <div key={`shimmer-${i}`} className="cast-item shimmer-cast">
            <div className="cast-shimmer-img" />
            <div className="cast-name shimmer cast-shimmer-text" />
            <div className="cast-role shimmer cast-shimmer-text" />
          </div>
        ))}
      </>
    );
  }

  return (
    <>
      {cast.slice(0, 5).map((actor, i) => (
        <div key={i} className="cast-item">
          <a href={`https://www.themoviedb.org/person/${actor.actor_id}`} target="_blank" rel="noreferrer">
            {actor.profile_path ? (
              <img
                src={`https://image.tmdb.org/t/p/w200${actor.profile_path}`}
                alt={actor.actor_name}
                onError={(e) => { e.target.onerror = null; e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
                style={{ width: '100%', maxWidth: '90px', height: '135px', borderRadius: '6px', objectFit: 'cover' }}
              />
            ) : (
              <div className="cast-placeholder" style={{ height: '135px', width: '90px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <i className="fa fa-user" style={{ fontSize: '40px', color: '#777' }}></i>
              </div>
            )}
          </a>
          <div style={{ minHeight: '52px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
            <div className="cast-name" style={{ maxHeight: '20px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{actor.actor_name}</div>
            <div className="cast-role" style={{ fontSize: '0.8rem', color: '#ccc', overflow: 'hidden', textOverflow: 'ellipsis', maxHeight: '32px' }}>{actor.character}</div>
          </div>
        </div>
      ))}
    </>
  );
};

export default CastList;